import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Configuration, Slider } from "@/shared-module/models";

@Component({
  selector: "app-slider",
  templateUrl: "slider.component.html",
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .range-control {
        position: relative;
      }

      output {
        position: absolute;
        right: 0;
        top: 0;
      }
    `,
  ],
})
export class SliderComponent implements OnInit, OnDestroy {
  @Input() sliderdata: Slider;
  @Input() min: number = 0;
  @Output() valuechanged: EventEmitter<number> = new EventEmitter();
  subs = new SubSink();
  rgbColor: string;
  ishover: boolean;
  readonly: boolean;

  constructor(private configurationService: ConfigurationService) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.rgbColor = c.rgb;
        thisObject.readonly = c.isDecisionReadOnly;
      },
    );
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  doSomething(v: number) {
    this.sliderdata.value = v;
    this.valuechanged.emit(v);
  }

  getStyle() {
    const fillPercentage = Math.round(
      ((this.sliderdata.value - this.min) / (10.0 - this.min)) * 100.0,
    );
    return (
      "linear-gradient(to right, " +
      this.rgbColor +
      " 0%, " +
      this.rgbColor +
      " " +
      fillPercentage +
      "%, rgba(255, 255, 255, 0.4) " +
      fillPercentage +
      "%, rgba(255, 255, 255, 0.4) 100%)"
    );
  }

  over() {
    this.ishover = true;
  }

  out() {
    this.ishover = false;
  }
}
